import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';
import EmojiEmotionsOutlined from '@mui/icons-material/EmojiEmotionsOutlined';

import { Button } from 'uikit/buttons';

import EmojiPicker from './emojiPicker';

import styles from '../styles/uikitReactionsEmojiButton.module.scss';

const EmojiButton = ({ emojiPickerPosition, onSelect = () => {} }) => {
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  const onClick = () => {
    setIsEmojiPickerOpen(true);
  };

  const onClose = () => {
    setIsEmojiPickerOpen(false);
  };

  return (
    <div className={styles.element}>
      <Button
        ariaLabel={i18n.t('emoji-picker-open-aria-label')}
        icon={<EmojiEmotionsOutlined />}
        variant="ghost"
        onClick={onClick}
        testId="uikit-emoji-button"
      />
      <EmojiPicker
        className={classnames(styles.element, styles[emojiPickerPosition])}
        onEmojiSelect={onSelect}
        isActive={isEmojiPickerOpen}
        onClickOutside={onClose}
      />
    </div>
  );
};

EmojiButton.propTypes = {
  emojiPickerPosition: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};

export default EmojiButton;
